module.exports = __webpack_public_path__ + "media/images/application-complete-6bd07af5.svg";